<template>
  <div class="not-shipped-orders">
    <el-form 
      ref="shippingForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="shipping-form">
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="样品数量" prop="sampleCount">
              <el-input v-model="form.sampleCount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isForwardPending">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <el-form-item label="商家名称" prop="targetMerchantName">
              <el-input v-model="form.targetMerchantName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" v-if="!isForwardPending">  
            <el-form-item label="仪器信息" prop="deviceName">
              <el-input v-model="form.deviceName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isForwardPending">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="form.contactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 转寄订单专用行 -->
        <el-row :gutter="20" v-if="isForwardPending">
          <el-col :span="12">
            <el-form-item label="联系人" prop="targetContactPerson">
              <el-input v-model="form.targetContactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="targetContactPhone">
              <el-input v-model="form.targetContactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" v-if="!isForwardPending">
            <el-form-item label="联系方式" prop="contactPhone">
              <el-input v-model="form.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isForwardPending">
            <el-form-item label="地址" prop="address">
              <el-input v-model="form.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 转寄订单地址行 -->
        <el-row :gutter="20" v-if="isForwardPending">
          <el-col :span="24">
            <el-form-item label="地址" prop="targetAddress">
              <el-input v-model="form.targetAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 邮寄信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>邮寄信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="物流公司" prop="expressCompany">
              <el-select v-model="form.expressCompany" placeholder="请选择物流公司">
                <el-option
                  v-for="item in logisticsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号" prop="trackingNo">
              <el-input v-model="form.trackingNo" placeholder="请输入快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮寄日期" prop="estimatedArrivalTime">
              <el-date-picker
                v-model="form.estimatedArrivalTime"
                type="date"
                placeholder="选择邮寄日期"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确认邮寄</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'NotShippedOrders',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isForwardPending: false, // 是否为待转寄状态
      logisticsOptions: [], // 物流公司列表
      form: {
        projectName: '',
        orderNo: '',
        sampleCount: '',
        merchantName: '',
        deviceName: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        expressCompany: '',
        trackingNo: '',
        estimatedArrivalTime: this.formatCurrentDate(),
        // 转寄订单额外字段
        targetMerchantName: '',
        targetContactPerson: '',
        targetContactPhone: '',
        targetAddress: ''
      },
      rules: {
        expressCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        trackingNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
        ],
        estimatedArrivalTime: [
          { required: true, message: '请选择邮寄日期', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 获取订单详情
    this.getOrderDetail()
    // 获取物流公司列表
    this.fetchLogisticsList()
  },
  methods: {
    // 获取物流公司列表
    async fetchLogisticsList() {
      try {
        const res = await adminApi.getLogisticsList()
        if (res && Array.isArray(res)) {
          // 转换为select需要的格式
          this.logisticsOptions = res.map(item => ({
            value: item.trackCode,
            label: item.trackName
          }))
        } else {
          this.$message.warning('获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.$message.error('获取物流公司列表失败: ' + (error.message || '未知错误'))
      }
    },
    // 格式化当前日期为yyyy-MM-dd HH:mm:ss格式
    formatCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} 00:00:00`
    },
    async getOrderDetail() {
      try {
        const res = await adminApi.getOrderById(this.orderId)
        if (res) {
          // 判断是否为转寄订单且isForwardEnd为0
          this.isForwardPending = res.orderStatus === 'FORWARD' && res.isForwardEnd === 0
          
          if (this.isForwardPending && res.orderReturnForwardList && res.orderReturnForwardList.length > 0) {
            // 从转寄记录获取信息
            const forwardInfo = res.orderReturnForwardList[0]
            this.form = {
              ...this.form,
              projectName: res.projectName || '',
              orderNo: res.orderSn || '',
              sampleCount: res.testCount || '',
              // 转寄单特有数据
              targetMerchantName: forwardInfo.targetMerchantName || '',
              targetContactPerson: forwardInfo.targetMerchantPerson || '',
              targetContactPhone: forwardInfo.targetMerchantPhone || '',
              targetAddress: forwardInfo.targetMerchantAddress || ''
            }
          } else {
            // 普通订单信息处理
            this.form = {
              ...this.form,
              projectName: res.projectName || '',
              orderNo: res.orderSn || '',
              sampleCount: res.testCount || '',
              merchantName: res.merchantName || '',
              deviceName: res.deviceName || '',
              contactPerson: res.merchantPerson || '',
              contactPhone: res.merchantPhone || '',
              address: res.merchantAddress || ''
            }
          }
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.shippingForm.validate(async valid => {
        if (valid) {
          try {
            // 获取快递公司名称
            const expressCompanyName = this.logisticsOptions.find(
              option => option.value === this.form.expressCompany
            )?.label || this.form.expressCompany;
            
            await adminApi.editOrder({
              id: this.orderId,
              orderStatus: 'IN_TRANSIT',
              trackSn: this.form.trackingNo,
              trackName: expressCompanyName, // 提交物流公司名称而非代码
              trackTime: this.form.estimatedArrivalTime,
              remarks: ''
            })
            this.$message.success('邮寄信息提交成功')
            
            // 根据用户角色决定跳转路径
            const userRole = localStorage.getItem('userRole')
            let basePath = '/admin'
            
            if (userRole === 'merchant') {
              basePath = '/merchant'
            } else if (userRole === 'customer') {
              basePath = '/customer'
            }
            
            // 跳转到对应角色的在途订单页面
            this.$router.push(`${basePath}/orders/in-transit`)
          } catch (error) {
            console.error('提交邮寄信息失败:', error)
            this.$message.error('提交邮寄信息失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.not-shipped-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.shipping-form {
  width: 100%;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 物流信息样式 */
.logistics-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #ecf5ff;
  border-radius: 4px;
}

.logistics-company {
  font-weight: bold;
  color: #409eff;
  margin-bottom: 10px;
}

.tracking-number {
  color: #606266;
  font-family: monospace;
}

/* 备注文本域样式 */
.remark-textarea textarea {
  min-height: 120px;
  resize: vertical;
}

/* 订单基本信息样式 */
.order-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-label {
  width: 120px;
  color: #606266;
  font-weight: bold;
}

.info-value {
  flex: 1;
  color: #303133;
}
</style> 